/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StudentInfo } from '../../models/student-info';

export interface IlsControllerGetAllStudentInfos$Params {
  ilsId: string;
}

export function ilsControllerGetAllStudentInfos(http: HttpClient, rootUrl: string, params: IlsControllerGetAllStudentInfos$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<StudentInfo>>> {
  const rb = new RequestBuilder(rootUrl, ilsControllerGetAllStudentInfos.PATH, 'get');
  if (params) {
    rb.path('ilsId', params.ilsId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<StudentInfo>>;
    })
  );
}

ilsControllerGetAllStudentInfos.PATH = '/ils/{ilsId}/studentInfos';
